import { styled } from '@mui/material/styles'

import { DialogTitleWrapper } from '../../wrapper'

export const DialogTitleStyle = styled(DialogTitleWrapper)(() => ({
  cursor: 'move',
}))
